import { API } from "../config/api";
import { DataService } from "../config/dataService/dataService";

class FinalCustomerTagsService {
  
  static async getTags ({page, search}) {
    const params = {
      page,
      search
    };
    const { data } = await DataService.get(API.serviceFinalCustomersTags.root, params);
    return {
      finalCustomerTags: data.finalCustomerTags,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getTagsById(tagsId) {
    const { data } = await DataService.get(`${API.serviceFinalCustomersTags.root}/${tagsId}`);
    return {
      finalCustomerTag: data.finalCustomerTag,
    };
  }

  static async createFinalCustomerTags(data) {
    const tagsData = {
      name: data.name,
      description: data.description,
    };
    const { data: newData } = await DataService.post(API.serviceFinalCustomersTags.root, tagsData);
    return {
      finalCustomerTags: newData.finalCustomerTags,
    };
  }

  static async updateFinalCustomerTags(id, newData) {
    const tagsData = {
      name: newData.name,
      description: newData.description,
    };
    const { data } = await DataService.patch(`${API.serviceFinalCustomersTags.root}/${id}`, tagsData);
    return {
      finalCustomerTags: data.finalCustomerTags,
    };
  }

  static async removeFinalCustomerTags(id) {
    const { data } = await DataService.delete(`${API.serviceFinalCustomersTags.root}/${id}`);
    return {
      finalCustomerTags: data.finalCustomerTags,
    };
  }

}

export{FinalCustomerTagsService}